import React from 'react';
import '../css/Global.css';
function GlobalService(props) {
    const {content}=props;
  return (
    <div className=" col-md-3 m-3 global-item white-2 d-flex justify-content-center align-items-center flex-column" >
    <ion-icon name="bar-chart-outline" style={{fontSize:"30px"}}>
</ion-icon>
    <h6 className="mt-2 letter-dis-1"> {content}</h6>
    </div>
    )
}

export default GlobalService;
